import { useContext } from "react";
import { FileTypes, KindOfOrder } from "../../../../types/enums";
import { FileAttachmentsButton } from "../../../common";
import { RefetchScope, PurchaseOrderContext } from "../context/PurchaseOrderContext";

export default function PurchaseOrderFilesButton(props: { defaultFileType?: FileTypes }) {

	const { order, refetchOrder } = useContext(PurchaseOrderContext);

	return (
		<FileAttachmentsButton
			attachedFiles={order.details.files}
			orderID={order.details.purchaseOrderID}
			parentGuid={order.details.guid}
			kindOfOrder={KindOfOrder.PurchaseOrder}
			defaultFileType={props.defaultFileType}
			useFileTypes={true}
			onFileAdded={() => refetchOrder(RefetchScope.Files)}
			onFileDeleted={() => refetchOrder(RefetchScope.Files)}
		/>
	)
}
